// extracted by mini-css-extract-plugin
export var cartContainer = "_p6-4";
export var gray = "_p6-1";
export var itemContainer = "_p6-2";
export var itemDetails = "_p6-3";
export var strong = "_p6-0";